import {
  REQUESTS_REQUEST,
  REQUESTS_SUCCESS,
  REQUESTS_ERROR,
  REQUESTS_ADD_REQUEST,
  REQUESTS_ADD_SUCCESS,
  REQUESTS_ADD_ERROR,
} from "../actions/requests";
import HTTP from "@/utils/http";
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";

const state = {
  requests_get_status: "",
  requests_once_loaded: false,
  requests: [],
  requests_add_status: "",
};

const getters = {
  getRequests: state => state.requests,
  getRequestsCount: state => state.requests ? state.requests.length : 0,
  isRequestsLoading: state => state.requests_get_status === 'loading',
  isRequestsFailed: state => state.requests_get_status === 'error',
  requestsOnceLoaded: state => state.requests_once_loaded,
};

const actions = {
  [REQUESTS_REQUEST]: ({ commit, dispatch }) => {
    commit(REQUESTS_REQUEST);
    HTTP({ url: "requests" })
      .then(resp => {
        commit(REQUESTS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(REQUESTS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
  [REQUESTS_ADD_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(REQUESTS_ADD_REQUEST);
      HTTP({ url: "requests", data: req, method: "POST" })
        .then(resp => {
          commit(REQUESTS_ADD_SUCCESS, { resp: resp.data, req });
          resolve(resp);
        })
        .catch(err => {
          commit(REQUESTS_ADD_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
};

const mutations = {
  [REQUESTS_REQUEST]: state => {
    state.requests_get_status = "loading";
  },
  [REQUESTS_SUCCESS]: (state, data) => {
    state.requests_get_status = "success";
    Vue.set(state, "requests", data);
    state.requests_once_loaded = true;
  },
  [REQUESTS_ERROR]: state => {
    state.requests_get_status = "error";
    state.requests_once_loaded = true;
  },

  [REQUESTS_ADD_REQUEST]: state => {
    state.requests_add_status = "loading";
  },
  [REQUESTS_ADD_SUCCESS]: (state, data) => {
    state.requests_add_status = "success";
    state.requests.unshift({ id: data.resp, body: JSON.parse(data.req.body), date: new Date().toISOString(), });
  },
  [REQUESTS_ADD_ERROR]: state => {
    state.requests_add_status = "error";
  },

  [AUTH_LOGOUT]: state => {
    state.requests_get_status = "";
    state.requests_once_loaded = false;
    state.requests = [];
    state.requests_add_status = "";
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};